import { createFileRoute, redirect } from '@tanstack/react-router'
import { PlansListPage } from '@/pages/Plans/PlansListPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/plans')({
  component: PlansListPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/plans')) {
      throw redirect({ to: '/' })
    }
  },
})
